export default __webpack_public_path__ + "static/media/delivered.9193911c.png";